import { Locale, LOCALE, LOCALES } from "@/constants";
import { ROUTES } from "@/routes_new";
import { generatePath, Redirect, useLocation } from "react-router-dom";

const browserLang = navigator.language?.slice(0, 2);
const resolvedBrowserLang = LOCALES.includes(browserLang as Locale)
  ? (browserLang as Locale)
  : LOCALE.ENGLISH;

export default function SignupRedirectView() {
  const { search } = useLocation();

  return (
    <Redirect
      to={`${generatePath(ROUTES.SIGNUP_LOCALIZED, {
        language: resolvedBrowserLang,
      })}${search}`}
    />
  );
}
